<template lang="html">
  <div>
    <div v-if="data.cnt">
      <input
          v-for="idx in data.cnt"
          class="oneLetter"
          style="text-transform:uppercase"
          ref="letters"
          :key="idx"
          maxlength="1"
          value=" "
          @focusin="data.idx=idx"
          @click="select()"
          @keyup="onKeyup"
          @paste="onPaste"
      >
    </div>
    <div v-else :class="[data.val === '' ? 'wrapInp' : 'wrapInp disabled']">
      <input
          :type="type"
          :id="data.title"
          v-model="data.val"
          :maxlength="maxlength"
          :disabled="disable"
      />
      <label :for="data.title">{{data.title}}
        <span v-if="data.title=='CVC'" class="cnt">
        <img src="https://icongr.am/clarity/help.svg?size=15&color=ffffff" @click="$emit('showCvcInfo')">
      </span>
      </label>
    </div>

  </div>
</template>

<script>
import {int, require, digits, date, eng, numReg, validateVehicleNo} from "../../helpers/Validate";

export default {
  props: {
    data: {
      cnt: 17,
      val: '',
      title: '',
      func: {name: null},
      idx: 1,
    },
    disable: Boolean,
    type: {
      type: String,
      default: "text"
    },
    max: {
      type: Number,
      default: 20
    },
  },
  computed: {
    maxlength() { return this.max; }
  },
  data() {
    return {
      activate: false,
      pasted: false,
    }
  },
  created() {
    if(this.data)
      this.checkVaild();
  },
  methods: {
    getVal(){
      this.data.val = '';
      for (let i=0; i < this.data.cnt; i++){
        let val = this.$refs['letters'][i].value;
        val = val.trim() === ''? ' ': val;
        this.data.val += val;
      }
    },

    setVal(){
      for (let i=0; i < this.data.cnt; i++){
        this.$refs['letters'][i].value = this.data.val[i]||' ';
      }
    },


    checkVaild() {
      const val = this.data.val;
      switch (this.data.func.name) {
        case 'validateNo': {
          this.data.validate = validateVehicleNo(val);
          break
        }
        case 'require' : {
          this.data.validate = require(val);
          break;
        }
        case 'numReg' : {
          this.data.validate = numReg(val);
          break;
        }
        case 'digits' : {
          this.data.validate = digits(val, this.data.func.n, this.data.func.comparison);
          break;
        }
        case 'digitsInt' : {
          this.data.validate = digits(int(val), this.data.func.n, this.data.func.comparison);
          break;
        }
        case 'date' : {
          this.data.validate = date(val);
          break;
        }
        case 'eng': {
          this.data.validate = eng(val);
          break;
        }
        default: {
          this.data.validate = true;
        }
      }
    },

    select(){
      this.$refs.letters[this.data.idx-1].select();
    },

    onKeyup(e) {

      if (this.data.cnt < 2) return;

      if (this.pasted){
        this.pasted = false;
        return;
      }
      this.$refs.letters[this.data.idx-1].value = this.$refs.letters[this.data.idx-1].value.toUpperCase();
      if(['backspace', 'arrowleft'].includes(e.code.toLowerCase()) || ['backspace', 'arrowleft'].includes(e.key.toLowerCase())) {
        if (this.data.idx > 1) this.data.idx -= 1;

      } else if(
          /^[a-zA-Z0-9]$/.test(e.key)
          || 'unidentified' === e.key.toLowerCase()
          || 'arrowright' === e.code.toLowerCase()
          || 'arrowright' === e.key.toLowerCase()
      ) {
        if(this.data.idx < this.data.cnt) this.data.idx += 1;
      }

      this.select();
      this.getVal();
      this.checkVaild();
    },

    onPaste(e) {
      if (this.data.cnt < 2) return;

      this.data.val = e.clipboardData.getData('text').toUpperCase();
      this.setVal();
      this.checkVaild();
      e.preventDefault();
      this.data.idx = 1;
      this.pasted = true;
    },

  },
  watch: {
    'data.val'() {
      this.setVal();
      this.checkVaild();
      this.$emit('change', this.data);
    },
  },
}
</script>

<style lang="css" scoped>
.v-application ul {
  padding-left: 0px;
}

p {
  padding: 9px 10px 0;
  color: #7f8081;
  font-size: 13px;
  line-height: 16px;
  margin-bottom: 16px;
}

.err {
  color: #ff3636;
}
</style>

